import { getDynamicSetting } from 'utils/dynamicSettings';

const serverUrl = getDynamicSetting('server_url');

export const BASE_URL = serverUrl;

export const ERROR_TRACK_EVENTS = {
  GET_BATCH_METRICS: 'get_batch_metrics_error',
} as const;
